import { render } from "./Overlay.vue?vue&type=template&id=3d8b3f5b&scoped=true&ts=true"
import script from "./Overlay.vue?vue&type=script&lang=ts"
export * from "./Overlay.vue?vue&type=script&lang=ts"

import "./overlay.scss?vue&type=style&index=0&id=3d8b3f5b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8b3f5b"]])

export default __exports__